import { useContext } from 'react';
import MethodContext, { MethodContextType } from './MethodContext';

export default function useMethodContext(): MethodContextType {
    const ctx = useContext(MethodContext) as MethodContextType;
    if (ctx === null) throw new Error('No MethodContext provided');
    return ctx;
}
